import { Form, Input, Button, Typography } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { useVerify2FA } from '../../hooks/useAuth';
import { useAuthStore } from '../../stores/authStore';
import { Navigate } from 'react-router-dom';

const { Text } = Typography;

export function TwoFactorPage() {
  const tempToken = useAuthStore((s) => s.tempToken);
  const accessToken = useAuthStore((s) => s.accessToken);
  const verify = useVerify2FA();

  // If we have an access token, verification succeeded - redirect to dashboard
  if (accessToken) {
    return <Navigate to="/" replace />;
  }

  // If no temp token and no access token, redirect to login
  if (!tempToken) {
    return <Navigate to="/login" replace />;
  }

  const onFinish = (values: { code: string }) => {
    verify.mutate({ temp_token: tempToken, code: values.code });
  };

  return (
    <Form layout="vertical" onFinish={onFinish}>
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        Enter the 6-digit code from your authenticator app.
      </Text>
      <Form.Item name="code" rules={[{ required: true, len: 6, message: 'Enter 6-digit code' }]}>
        <Input prefix={<SafetyOutlined />} placeholder="000000" size="large" maxLength={6} style={{ letterSpacing: 8, textAlign: 'center' }} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={verify.isPending} block size="large">
          Verify
        </Button>
      </Form.Item>
    </Form>
  );
}
